import {isFeatureEnabled} from '@github-ui/feature-flags'
import {reportError} from '@github-ui/failbot'

const SLDE_FEATURE = 'actions_workflow_run_logs_slde'

export type WorkflowRunsRuntime = 'legacy' | 'slde'
export type WorkflowRunsRuntimeImporters = Readonly<{
  legacy: () => Promise<unknown>
  slde: () => Promise<unknown>
}>

let runtimeLoad: Promise<WorkflowRunsRuntime> | undefined
const importers: WorkflowRunsRuntimeImporters = {
  legacy: () => import('./legacy-entry'),
  slde: () => import('./slde-entry'),
}

export function selectWorkflowRunsRuntime(): WorkflowRunsRuntime {
  return isFeatureEnabled(SLDE_FEATURE) ? 'slde' : 'legacy'
}

export function loadWorkflowRunsRuntime(): Promise<WorkflowRunsRuntime> {
  runtimeLoad ??= loadSelectedWorkflowRunsRuntime()
  return runtimeLoad
}

async function loadSelectedWorkflowRunsRuntime(): Promise<WorkflowRunsRuntime> {
  return importWorkflowRunsRuntime(selectWorkflowRunsRuntime(), importers)
}

export async function importWorkflowRunsRuntime(
  runtime: WorkflowRunsRuntime,
  runtimeImporters: WorkflowRunsRuntimeImporters,
): Promise<WorkflowRunsRuntime> {
  if (runtime === 'slde') {
    try {
      await runtimeImporters.slde()
      return runtime
    } catch (error) {
      reportError(error)
      await runtimeImporters.legacy()
      return 'legacy'
    }
  }

  await runtimeImporters.legacy()
  return runtime
}
